module.exports = __webpack_public_path__ + "static/media/salisbury-27.cbc2ebf4.jpg";